import { getAvatarMaterials } from './avatarMaterial'

// Apply / clear / re-intensity the specular envMap on the avatar's materials,
// through the native `envMap` property.
//
// Every one of these used to skip a toon-graph material, which has no native
// envMap and was fed a PMREM through injected GLSL instead. Both halves of that
// are gone — the toon material model was removed outright — so nothing sets the
// `userData.isToonGraph` those guards read, and the setters they deferred to
// iterated every material and skipped every one.

export function applyEnvToAll(envTexture, envMapIntensity) {
  const mats = getAvatarMaterials()?._all ?? []
  for (const mat of mats) {
    if (!mat) continue
    mat.envMap = envTexture
    mat.envMapIntensity = envMapIntensity
    mat.needsUpdate = true
  }
}

export function clearEnvFromAll(target) {
  const mats = getAvatarMaterials()?._all ?? []
  for (const mat of mats) {
    if (mat && mat.envMap === target) {
      mat.envMap = null
      mat.needsUpdate = true
    }
  }
}

export function setEnvIntensityOnAll(envMapIntensity) {
  const mats = getAvatarMaterials()?._all ?? []
  for (const mat of mats) {
    if (mat && mat.envMap) {
      mat.envMapIntensity = envMapIntensity
      mat.needsUpdate = true
    }
  }
}
